import type { PropsWithChildren } from "react"
import React from "react"

import { useHydrateQuiz } from "lib/quiz"

import type { GetQuizDataProps } from "lib/quiz/types"

import { quizLayout, quizPagesWrapper, layoutWrapper } from "./style.css"

type Props = PropsWithChildren & {
  showTrustPilotReviewsWidget: boolean
  data: GetQuizDataProps
}

export const QuizLayout: React.FC<Props> = ({ children, data }) => {
  useHydrateQuiz(data)

  return (
    <div className={quizLayout} data-testid="QuizLayout">
      <div className={layoutWrapper}>
        <div className={quizPagesWrapper}>{children}</div>
      </div>
    </div>
  )
}
